module.exports = __webpack_public_path__ + "static/media/Implant-Assembly.3007dc60.svg";